import React from "react";
import { VendingTableDataType, TableVendingData } from "./Types"; 
import { formatCurrency, formatDate, getPaymentMethodDisplayName } from "../../../helper/helper";
import StatusIndicator from "../../StatusIndicator/StatusIndicator";
import Table from "../../Table/CustomTable/Table";
import Pagination from "../../Pagination/Pagination";
import CopyTextToClipboard from "../../CopyToClipboard/CopyToClipboard";

interface DesktopVendingProps {
  setSelectedTransaction: React.Dispatch<React.SetStateAction<VendingTableDataType | null>>;
  setShowTransactionModal: React.Dispatch<React.SetStateAction<boolean>>;
  handlePageChange: (page: number) => void;
  handleTableActionClick: (id: number) => void;
  setOpen: React.Dispatch<React.SetStateAction<boolean>>;
  open: boolean;
  data: any[];
  selectedIconIndex: number | null;
  currentPageNumber: number;
  loading?: boolean;
  totalCount?: number;
  pageSize?: number;
  showViewAll?: boolean;
}

const DesktopVending: React.FC<DesktopVendingProps> = (props) => {
  const {
    data,
    currentPageNumber,
    open,
    pageSize,
    totalCount,
    setSelectedTransaction,
    setShowTransactionModal,
    handlePageChange,
    setOpen,
  } = props;

  const tableHeadAdmin: {
    name: keyof TableVendingData;
    displayName: string;
  }[] = [
    { name: "customerName", displayName: "Customer Name" },
    { name: "meterNumber", displayName: "Meter Number" },
    { name: "token", displayName: "Token Number" },
    { name: "units", displayName: "Units" },
    { name: "amount", displayName: "Amount" },
    { name: "paymentMethodValue", displayName: "Payment Method" },
    { name: "transactionDate", displayName: "Date" },
    { name: "paymentStatusValue", displayName: "Status" },
    
  ];

  

  return (
    <>
      <div className="overflow-x-scroll ">
        <Table<TableVendingData, VendingTableDataType>
          fields={tableHeadAdmin}
          tableData={data}
          // isLoading={isLoading}
          rows={10}
          handleRowClick={(item: VendingTableDataType) => {
            setSelectedTransaction(item);
            setShowTransactionModal(true);
          }}
          builder={(field: any, data: VendingTableDataType) => {
            switch (field.name) {
              case "token":
                return (
                  <div
                    onClick={(event: React.MouseEvent<HTMLDivElement>) => {
                      event.stopPropagation();
                    }}
                  >
                    {data.token ? <CopyTextToClipboard textToCopy={data?.token} /> : "---------"}
                  </div>
                );
              case "amount":
                return <div>{formatCurrency(data?.amount)}</div>;
              case "transactionDate":
                return <div>{data?.transactionDate ? formatDate(data?.transactionDate) : "---------"}</div>;
              case "paymentMethodValue":
                return <div>{getPaymentMethodDisplayName(data?.paymentMethodValue)}</div>;
              case "paymentStatusValue":
                return (
                  <div>
                    <StatusIndicator incomingStatus={data?.paymentStatusValue} />
                  </div>
                );
               
              default:
                return data[field?.name as keyof VendingTableDataType];
            }
          }}
        />
      </div>
      {!props.showViewAll && (
        <div className="w-full mt-4">
          <Pagination
            totalItems={totalCount || 0}
            itemsPerPage={pageSize || 10}
            onPageChange={handlePageChange}
            currentPage={currentPageNumber}
          />
        </div>
      )}
    </>
  );
};

export default DesktopVending;
